import { Link } from "@tanstack/react-router";

export function Footer() {
    return (
        <footer className="border-t border-border/20 py-6 hidden md:block">
            <div className="container mx-auto px-4 sm:px-6">
                <div className="text-center space-y-4">
                    <div className="space-x-6">
                        <Link to="/help" className="text-sm text-muted-foreground hover:text-foreground underline">
                            Help
                        </Link>
                        <Link to="/privacy" className="text-sm text-muted-foreground hover:text-foreground underline">
                            Privacy Policy
                        </Link>
                        <Link to="/terms" className="text-sm text-muted-foreground hover:text-foreground underline">
                            Terms of Service
                        </Link>
                    </div>
                    <p className="text-xs text-muted-foreground">
                        StoryDoodle is designed for ages 13+ with parental supervision for younger children.
                    </p>
                    <p className="text-xs text-muted-foreground">
                        © {new Date().getFullYear()} StoryDoodle. All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
}
